import { useLocation, matchPath } from "react-router-dom";
import DynamicHead from "src/components/shared/atoms/helmet";
import pathTitleMap from "./pathTitleMap";

const DynamicTitleWrapper = () => {
  const { pathname } = useLocation();

  let title = pathTitleMap[pathname];

  // Handle dynamic route like /resetpassword/:token/:email
  if (!title && matchPath("/resetpassword/:token/:email", pathname)) {
    title = "Reset Password";
  }

  return <DynamicHead title={title || "KuikWit"} />;
};

export default DynamicTitleWrapper;
